module.exports = kolibriGlobal.coreVue.components.CoreLogo;